module.exports = __webpack_public_path__ + "img/d13.9befe5e6.png";